module.exports = __webpack_public_path__ + "static/img/icon-club-nmfc.3780b40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-club-nmfc.svg
// module id = UX2h
// module chunks = 0